import {
    IconBluetooth, IconCard, IconFace, IconFingerprint, IconLaptop, IconMobile, IconPin, IconPlate, IconQr,
    IconTag, CloseIcon, IconFaceQr, IconFingerQr, IconRemoteDoor
} from "../components/buttons/IconButtons"

export const accessMethod = {
    1: 'tag',
    2: 'fingerprint',
    3: 'nfc_card',
    4: 'qr_code',
    5: 'face_recognition',
    6: 'pin',
    7: 'fingerprint_pda',
    8: 'bluetooth',
    9: 'web_app',
    10: 'mobile_app',
    11: 'zone_opt',
    12: 'document',
    13: 'plates',
    14: 'fingerprint',
    15: 'fingerprint',
    16: 'signo_25B',
    17: '2_FA_QR_HUELLA',
    18: '2_FA_QR_SELFIE',
    19: 'remote_door',
};

export const accessMethodModel = {
    TAG: {
        id: 1,
        value: accessMethod['1'],
        icon: IconTag
    },
    FINGER_PRINT: {
        id: 2,
        value: accessMethod['2'],
        icon: IconFingerprint
    },
    NFC_CARD: {
        id: 3,
        value: accessMethod['3'],
        icon: IconCard
    },
    QR_CODE: {
        id: 4,
        value: accessMethod['4'],
        icon: IconQr
    },
    FACE_RECOGNITION: {
        id: 5,
        value: accessMethod['5'],
        icon: IconFace
    },
    PIN: {
        id: 6,
        value: accessMethod['6'],
        icon: IconPin
    },
    FINGER_PRINT_PDA: {
        id: 7,
        value: accessMethod['7'],
        icon: IconFingerprint
    },
    BLUETOOTH: {
        id: 8,
        value: accessMethod['8'],
        icon: IconBluetooth,
    },
    WEB_APP: {
        id: 9,
        value: accessMethod['9'],
        icon: IconLaptop,
    },
    MOBILE_APP: {
        id: 10,
        value: accessMethod['10'],
        icon: IconMobile
    },
    ZONE_OPT: {
        id: 11,
        value: accessMethod['11'],
        icon: CloseIcon
    },
    DOCUMENT: {
        id: 12,
        value: accessMethod['12'],
        icon: CloseIcon
    },
    PLATES: {
        id: 13,
        value: accessMethod['13'],
        icon: IconPlate
    },
    FINGER_PRINT_ANSI: {
        id: 14,
        value: accessMethod['14'],
        icon: IconFingerprint
    },
    FINGER_PRINT_ISO: {
        id: 15,
        value: accessMethod['15'],
        icon: IconFingerprint
    },
    SIGNO_25B: {
        id: 16,
        value: accessMethod['16'],
        icon: CloseIcon
    },
    FA_QR_HUELLA: {
        id: 17,
        value: accessMethod['17'],
        icon: IconFingerQr
    },
    FA_QR_SELFIE: {
        id: 18,
        value: accessMethod['18'],
        icon: IconFaceQr
    },
    REMOTE_DOOR: {
        id: 19,
        value: accessMethod['19'],
        icon: IconRemoteDoor
    }
};

export const getAccessMethodById = (id) => {
    return Object.values(accessMethodModel).find((method) => method.id === id);
};

export const getAccessMethodLabel = (id, t) => {
    let e = Object.values(accessMethodModel).find((method) => method.id === id);

    if(e) return t(e.value)?.toUpperCase() || ('no_record').toUpperCase();
    return t('no_record').toUpperCase();
};

/**
 * Retrieves the corresponding access method icon.
 * @param {number} id - The access method ID.
 * @returns {string|JSX.Element|undefined} - The corresponding icon or undefined if not found.
 */
export const getAccessMethodIcon = (id) => {
    const method = Object.values(accessMethodModel).find(m => m.id === id);
    return method ? method.icon : undefined;
};

